import { alpha, Dialog, DialogContent, Stack, Typography, useTheme } from '@mui/material';
import { SuccessTickIcon } from '@zeta-core/assets';

interface Props {
  open: boolean;
}

const SuccessDialog = ({ open }: Props) => {
  const theme = useTheme();
  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogContent sx={{ backgroundColor: alpha(theme.palette.success.main, 0.08) }}>
        <Stack gap={2} alignItems="center" px={2} py={5}>
          <SuccessTickIcon />
          <Typography variant="body2" sx={{ color: theme.palette.success.darker }}>
            Information saved successfully!
          </Typography>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default SuccessDialog;
